import { supabase } from "@/integrations/supabase/client";

// Throttle: avoid logging the same path more than once per session
const logged = new Set<string>();

/**
 * Records a 404 hit. One row per unique path in not_found_log; repeat hits
 * increment hit_count and bump last_seen_at via the log_not_found() RPC.
 */
export async function logNotFound(source: "notfound" | "article", path?: string) {
  try {
    const p = path ?? (typeof window !== "undefined" ? window.location.pathname + window.location.search : "");
    if (!p) return;
    const key = `${source}::${p}`;
    if (logged.has(key)) return;
    logged.add(key);

    await (supabase as any).rpc("log_not_found", {
      p_path: p.slice(0, 1000),
      p_referrer: typeof document !== "undefined" ? document.referrer?.slice(0, 1000) || null : null,
      p_user_agent: typeof navigator !== "undefined" ? navigator.userAgent?.slice(0, 500) || null : null,
      p_source: source,
    });
  } catch {
    // Silent — diagnostic only
  }
}
